import { postP,get,getJ,put,deleteP,getExcel,uploadOther,uploadOthers,uploadOtherSort,upload,postOther,postPackage,getPDF,deletes  } from '@/utils/axios'
import  baseURL  from '@/utils/axios/axios'
import store from '../store'

export default {
    // 创建后台用户
    CreateUser(datas){
        return postP('Admin/CreateUser',datas)
    },
    // 修改后台用户
    UpdateUser(datas){
        return postP('Admin/UpdateUser',datas)
    },
    // 查询后台用户
    QueryUsers(datas){
        return postP('Admin/QuryUsers',datas)
    },

    

    // 获取角色列表
    QueryRole(datas){
        return get('Admin/QueryRole',datas)
    },
    // 更新角色
    UpdateRole(datas){
        return postP('Admin/UpdateRole',datas)
    },
    // 删除角色
    DeleteRole(datas){
        return deleteP('Admin/DeleteRole',datas)
    },
    // 创建后台用户角色
    CreateRole(datas){
        return postP('Admin/CreateRole',datas)
    },

    // 创建作业机构
    CreateMechanism(datas){
        return postP('Admin/CreateMechanism',datas)
    },
    // 修改作业机构
    UpdateMechanism(datas){
        return put('Admin/UpdateMechanism',datas)
    },
    // 删除作业机构
    deleteMechanism(datas){
        return deleteP('Admin/DeleteMechanism',datas)
    },
    // 作业机构列表
    QueryMechanism(datas){
        return get('Admin/QueryMechanism',datas)
    },
    // 作业机构详情
    QuryMechanismById(datas){
        return get('Admin/QuryMechanismById/'+datas)
    },
    

    // 添加伤者信息
    addHuman(datas){
        return postP('Human/Add',datas)
    },
    // 更新伤者信息
    updateHuman(datas){
        return put('Human/Update',datas)
    },
    // 更新伤者信息
    deleteHuman(datas){
        return deleteP('Human/DeleteHumanById',datas)
    },
    // 伤者详情
    queryHumanDetail(datas){
        return get('Human/QueryHumanByHumanId/'+datas)
    },
    // 案件Id查询伤者信息
    queryHumanByPiccHumanId(datas){
        return get('Human/queryHumanByPiccHumanId/'+datas)
    },
    
    // 通过伤者Id查询医院
    queryDcTaskMaterialByPiccHumanId(datas){
        return get('DcTaskMaterial/QueryDcTaskMaterialByPiccHumanId/'+datas)
    },
    // 通过伤者Id查询作业机构
    queryPiccHumanTaskByPiccHumanId(datas){
        return get('PiccHumanTask/QueryPiccHumanTaskByPiccHumanId/'+datas)
    },
    // 添加案件任务
    piccHumanTaskAdd(datas){
        return postP('PiccHumanTask/Add',datas)
    },
    // 删除案件任务
    piccHumanTaskDelete(datas){
        return deleteP('PiccHumanTask/DeleteByByPiccTaskHumanId',datas)
    },
    // 案件任务列表
    piccHumanTaskQueryPager(datas){
        return get('PiccHumanTask/QueryPager',datas)
    },
    // 案件任务详情
    queryPiccHumanTaskByPiccHumanId(datas){
        return get('PiccHumanTask/QueryPiccHumanTaskByPiccHumanId/'+datas)
    },

    // 查勘员——人伤列表
    querayPager_CK(datas){
        return get('Human/QuerayPager_CK',datas)
    },
    // 更新查勘伤者状态
    updateHumanStatus(datas){
        return put('Human/UpdateHumanStatus',datas)
    },
    // 调解员——人伤列表
    querayPager_TJ(datas){
        return get('Human/QuerayPager_TJ',datas)
    },
    // 更新查勘伤者状态
    updateHumanTjStatus(datas){
        return put('Human/UpdateHumanTjStatus',datas)
    },


    // 添加查勘資料
    addDcTaskMaterials(datas){
        return postP('DcTaskMaterial/Add',datas)
    },
    // 编辑查勘資料
    updateDcTaskMaterials(datas){
        return put('DcTaskMaterial/Update',datas)
    },
    queryDcTaskMaterialByHumanId(datas){
        return get('DcTaskMaterial/QueryDcTaskMaterialByHumanId/'+datas)
    },
    // 通过伤者Id查询医院
    queryHospitalByHumanId(datas){
        return get('Hospital/QueryHospitalByHumanId/'+datas)
    },

    // 添加医院信息
    HospitalAdd(datas){
        return postP('Hospital/Add',datas)
    },
    // 更新医院信息
    HospitalUpdate(datas){
        return put('Hospital/Update',datas)
    },
    // 删除医院信息
    HospitalDelete(datas){
        return deleteP('Hospital/Delete',datas)
    },


    // 通过伤者ID查询诊断信息
    queryZhenDuanInfoByHumanId(datas){
        return get('ZhenDuanInfo/QueryZhenDuanInfoByHumanId/'+datas)
    },
    // 添加诊断信息
    AddZhenDuanInfo(datas){
        return postP('ZhenDuanInfo/Add',datas)
    },
    // 修改诊断信息
    updateZhenDuanInfo(datas){
        return put('ZhenDuanInfo/Update',datas)
    },
    // 删除诊断信息
    deleteZhenDuanInfo(datas){
        return deleteP('ZhenDuanInfo/Delete',datas)
    },

    // 通过伤者ID查询定损信息
    lossInfoList(datas){
        return get('LossInfo/QueryLossInfoByHumanId/'+datas)
    },
    // 添加定损信息
    lossInfoAdd(datas){
        return postP('LossInfo/Add',datas)
    },
    // 更新定损信息
    lossInfoUpdate(datas){
        return put('LossInfo/Update',datas)
    },
    // 删除定损信息
    lossInfoDelete(datas){
        return deleteP('LossInfo/Delete',datas)
    },
    // 指派人员
    assignHuman(datas){
        return postP('Human/ZpHumanOperator',datas)
    },
    // 指派调查人员
    assignTjHuman(datas){
        return postP('Human/ZpHumanTjOperator',datas)
    },
    

    //创建后台资源
    createResource(datas){
        return postP('Admin/CreateResource',datas)
    },
    //删除资源
    deleteResource(datas){
        return deleteP('Admin/DeleteResource',datas)
    },
    //获取所有菜单资源
    queryResource(datas){
        return get('Admin/QueryResource',datas)
    },
    //修改权限
    updateResource(datas){
        return postP('Admin/UpdateResource',datas)
    },
    

    // 创建角色菜单
    createPermission(datas){
        return postP('Admin/CreatePermission',datas)
    },
    // 修改角色菜单
    updatePermission(datas){
        return postP('Admin/UpdatePermission',datas)
    },
    // 根据角色查询权限
    queryRoleResource(datas){
        return get('Admin/queryPermission/'+datas)
    },
    // 根据机构查询人员列表
    queryUserByMechanismId(datas){
        return get('Admin/QueryUserByMechanismId/'+datas)
    },
    // 查询当前机构人员列表
    queryUserByMechanismIds(datas){
        return get('Admin/QueryUserByMechanismIds',datas)
    },



    
    // 案件类列表
    piccHumanQueryPager(datas){
        return get('PiccHuman/QueryPager',datas)
    },
    // 今日跟踪
    piccHumanQueryPagerToday(datas){
        return get('PiccHuman/QueryPagerByToday',datas)
    },
    // 修改案件状态
    updatePiccHumanStatus(datas){
        return postP('PiccHuman/UpdatePiccHumanStatus',datas)
    },
    // 修改案件
    piccHumanUpdate(datas){
        return put('PiccHuman/Update',datas)
    },
    // 修改标的垫付和三者垫付和定损备注
    updateTarget_Three_DianFuFee_LossRemark(datas){
        return put('Human/UpdateTarget_Three_DianFuFee_LossRemark',datas)
    },
    // 修改案件任务状态
    updateTaskStatus(datas){
        return put('PiccHumanTask/UpdateTaskStatus',datas)
    },
    // 通过案件id查询案件
    piccHumanQueryByPiccHumanId(datas){
        return get('PiccHuman/QueryByPiccHumanId/'+datas)
    },

    queryPiccHumanTaskByPiccHumanId(datas){
        return get('PiccHumanTask/QueryPiccHumanTaskByPiccHumanId/'+datas)
    },

    // 编辑案件公估费
    updatePiccHumanFee(datas){
        return postP('PiccHuman/updatePiccHumanFee',datas)
    },
    // 添加日志
    insertLog(datas){
        return postP('PiccLog/InsertLog',datas)
    },
    // 通过案件id查询日志
    queryLogByPiccHumanId(datas){
        return get('PiccLog/queryLogByPiccHumanId',datas)
    },
    // 通过案件任务Id查询日志
    queryLogByPiccHumanTaskId(datas){
        return get('PiccLog/QueryLogByPiccHumanTaskId/'+datas)
    },
    // 通过伤者任务Id查询日志
    queryLogByHumanId(datas){
        return get('PiccLog/queryLogByHumanId/'+datas)
    },

    completePiccHumanTask(datas){
        return postP('PiccHumanTask/Complete',datas)
    },
    
    // 添加跟踪信息
    addTrackMsg(datas){
        return postP('PiccHumanTask/AddTrackMsg',datas)
    },
    // 更新下次跟踪时间
    updateNextTrackTime(datas){
        return put('PiccHumanTask/UpdateNextTrackTime',datas)
    },
    // 通过伤者id查询跟踪信息
    queryTrackMsgListByHumanId(datas){
        return get('PiccHumanTask/QueryTrackMsgListByPiccHumanTaskId/'+datas)
    },

    // 案件任务列表指派未完成
    queryPagerZpWwc(datas){
        return get('PiccHumanTask/QueryPagerZpWwc',datas)
    },

    // 查勘员角标提示
    messageCountCK_Message(datas){
        return get('MessageCount/CK_Message',datas)
    },

    // 查询所有人伤刚配置
    autoConfigureQueryAll(datas){
        return get('AutoConfigure/QueryAll',datas)
    },
    // 查询所有人伤刚配置
    autoConfigureAdd(datas){
        return postP('AutoConfigure/Add',datas)
    },
    autoConfigureUpdate(datas){
        return put('AutoConfigure/Update',datas)
    },
    autoConfigureDelete(datas){
        return deleteP('AutoConfigure/Delete',datas)
    },

    dcTaskMaterialDelete(datas){
        return deleteP('DcTaskMaterial/Delete',datas)
    },

    queryBusiness(datas){
        return get('Admin/QueryBusiness',datas)
    },

    // 通过主案件caseId查询标的车图片
    queryCarPicByCaseId(datas){
        return get('PiccHuman/QuerayCarPicByCaseId/'+datas)
    },
    // 导出数据
    exportExcel(datas,name){
        return getExcel('Common/Export',datas,name)
    },

    // 下载资料
    downFileDcTaskMaterial(datas,caseNo){
        return postPackage('Common/DownFileDcTaskMaterial/'+datas,{zipName:'报案号'+caseNo+'查勘资料'},)
    },
    downFileCarPicByCaseId(datas,caseNo){
        return postPackage('Common/DownFileCarPicByCaseId/'+datas,{zipName:'报案号'+caseNo+'现场查勘资料'},)
    },


    queryPiccHumanNumber(datas){
        return get('PiccHuman/QueryPiccHumanNumber',datas)
    },
    queryPiccHumanRequest(datas){
        return postP('PiccHuman/QueryPiccHumanRequest',datas)
    },


    uploadOther(file,params){
        return uploadOther('',file,params)
    },
    uploadOtherSort(file,params){
        return uploadOtherSort('',file,params)
    },
    uploadOthers(file,params){
        return uploadOthers('',file,params)
    },

    testQueryUsers(datas){
        return get('Test/QueryUsers',datas)
    },
    testUpdateUsers(datas){
        return postP('Test/UpdateUsers',datas)
    },
}